Alpine.store("customerImages", {
    count: 0,
    albumCount: 0,
    images: [],
    image: null,
    event_ids: [],
    debounce: null,
    loading: false,
    removeImages: [],

    init(){
        window.addEventListener('customerImages::load-saved-photos', () => this.loadSavedPhotos(null, true));
    },

    addImage(image, favorite=false, check=true, mainEventId=null) {
        if(check && this.openCreateAccount()) {
            this.image = image;
            this.image.favorite = favorite;
            return;
        }

        if(!image.saved) {
            this.count += 1;

            if(!image.print_only) {
                this.albumCount += 1;
            }
        }

        image.saved = true;
        image.favorite = favorite;

        this.images = this.images ?? [];
        this.removeImages = _.without(this.removeImages, image.id);

        this.images.push(image);
        this.images = _.uniqBy(this.images, 'id');

        this.event_ids = [...new Set([...this.event_ids, image.event_id])];
        this.update(mainEventId);

        this.dispatchImageChange(image);
    },

    dispatchImageChange(image) {
        window.dispatchEvent(
            new CustomEvent('album-change-image', {
                detail: { image: {...image} }
            })
        );
    },

    saveImage(){
        if (_.isEmpty(this.image)) {
            return;
        }

        this.addImage(this.image, this.image.favorite);
        this.image = null;
    },

    openCreateAccount(params = {}) {
        if (!Alpine.store('customer')?.hasInfo()) {
            window.dispatchEvent(new CustomEvent('open-create-account', {detail: params}));

            return true;
        }

        return false;
    },

    addManyImages(images, favorite=null) {
        if (this.openCreateAccount()) {
            this.image = images;
            return;
        }

        for (let image of images) {
            this.addImage(image, favorite, false);
        }
    },

    removeImage(imageId) {
        const removed = _.find(this.images, {id: imageId});

        this.images = _.reject(this.images, {id: imageId});
        this.removeImages.push(imageId);

        this.update();
        this.count -= 1;

        if(!removed || !removed.print_only) {
            this.albumCount -= 1;
        }
    },

    toggleImage(image, check=true) {
        if(!image.saved) {
            this.addImage(image);
            return;
        }

        image.saved = false;
        image.favorite = false;

        this.dispatchImageChange(image);
        this.removeImage(image.id);
    },

    async updateCount(){
        await this.loadSavedPhotos(null, true);
    },

    updateAllImagesAtCart(){
        const cart = Alpine.store('cart');

        if (!Array.isArray(cart.items)) {
            return;
        }

        cart.items.filter(item => item.images['all'])
            .map(item => {
                if (typeof this.images === 'undefined') {
                    return;
                }

                item.images['all'] = Object.values(this.images);
                cart.update();
            });
    },

    toggleFavoriteImage(image, mainEventId=null) {
        this.addImage(image, !image.favorite, true, mainEventId);
    },

    isFavorite(image) {
        return image?.favorite ?? false;
    },

    isSaved(image) {
        return image?.saved ?? false;
    },

    async clean(images=null) {
        if(!images) {
            this.images = [];
        } else {
            const imagesId = images.map((image) => {
                this.images = _.reject(this.images, {id: image.id});
                return {id: image.id}
            })

            let currentImages = [];
            this.updateAllImagesAtCart();

            while(imagesId.length) {
                currentImages = Object.fromEntries(imagesId.splice(0, 300));

                fetch('/sync', {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content
                    },
                    body: JSON.stringify({
                        images: [],
                        remove: currentImages,
                        main_event_id: Alpine.store('cart').mainEvent.id,
                    }),
                });
            }

            await this.updateCount();
            return;
        }

        this.update();
    },

    length() {
        return this.count;
    },

    albumLength() {
        return this.albumCount;
    },

    update(mainEventId=null) {
        clearTimeout(this.debounce);

        this.debounce = setTimeout(() => this.flushSync(mainEventId), 500);
    },

    flushSync(mainEventId=null) {
        let removedImages = _.uniq(
            _.filter([...this.removeImages])
        );

        let currentImages = _.reduce(this.images, (images, image) => {
            if (!image.id) {
                return
            }

            images[image.id] = _.get(image, 'favorite', false);
            return images;
        }, {});

        if(_.isEmpty(removedImages) && _.isEmpty(currentImages)) {
            return Promise.resolve();
        }

        return fetch('/sync', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'X-CSRF-TOKEN': document.head.querySelector('meta[name=csrf-token]').content
            },
            body: JSON.stringify({
                add: currentImages,
                remove: removedImages,
                main_event_id: mainEventId ?? Alpine.store('cart').mainEvent?.id,
            }),
        }).then((response) => {
            if (!response.ok) {
                this.notifySyncFailure();
                return;
            }

            this.images = _.filter(this.images, ({ id }) => !_.has(currentImages, id));
            this.removeImages = _.filter(this.removeImages, (id) => !removedImages.includes(id));
            removedImages = null;
        }).catch(() => this.notifySyncFailure());
    },

    notifySyncFailure() {
        window.dispatchEvent(new CustomEvent('customerImages::sync-failed'));

        window.$wireui?.notify({
            title: 'Update Failed.',
            description: 'We could not save your change, please try again!',
            icon: 'warning'
        });
    },

    groupedImages(images=null) {
        return _.groupBy(Object.values(images ?? this.images), "event_id");
    },

    favorites(grouped=false) {
        const images = Object.values(this.images)
            .filter(image => image.favorite);

        return grouped
            ? this.groupedImages(images)
            : images;
    },

    async loadSavedPhotos(mainEventId=null, refresh=false, callback=null){
        const mainEvent = mainEventId ?? Alpine.store('cart').mainEvent.id;

        if(!mainEvent) {
            return;
        }

        if (refresh || !this.count) {
            this.loading = true;

            await fetch('/customer/images?totals&mainEventId=' + mainEvent)
                .then(response => response.json())
                .then(({ total, album_total = 0, event_ids = '' }) => {
                    if(typeof callback === 'function') {
                        callback(total);
                    }

                    this.count = total;
                    this.albumCount = album_total;
                    this.event_ids = event_ids?.split(',') ?? [];

                    this.loading = false;
                });
        }
    },

    async myAlbum($dispatch, refresh = false, options={}) {
        $dispatch('saved-photos', options);
    },

    async goToCheckoutWizard(mainEventId) {
        window.location.href = `/checkout/${mainEventId}/photo-package?requestPhotos=true`;
    },

    async goToProducts(mainEventId) {
        window.location.href = `/checkout/${mainEventId}/products?requestPhotos=true`;
    }
});
